import { render, staticRenderFns } from "./get-started.vue?vue&type=template&id=176e9dc8&"
import script from "./get-started.vue?vue&type=script&lang=js&"
export * from "./get-started.vue?vue&type=script&lang=js&"
import style0 from "./get-started.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports